module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.videos), function(video) {
    return _c('section', {
      staticClass: "card p-4 d-flex flex-direction-column justify-space-between"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('router-link', {
      staticClass: "fs-5 break-word mr-2",
      attrs: {
        "to": '/videos/' + video.id
      }
    }, [_vm._v("\n          " + _vm._s(video.title) + "\n        ")]), _vm._v(" "), (video.is_shared && !video.shared) ? _c('div', {
      staticClass: "d-flex",
      attrs: {
        "data-balloon": "Shared",
        "data-balloon-pos": "up"
      }
    }, [_c('SharedWithUsersIcon')], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "border"
    }, [(!video.processed && !video.transcode_error) ? _c('p', [_vm._v("Processing")]) : (video.transcode_error) ? _c('p', [_vm._v("Error!")]) : _vm._e(), _vm._v(" "), (!video.shared) ? _c('div', [_c('span', {
      staticClass: "bold text-muted"
    }, [_vm._v(_vm._s(video.user.name || video.user.email))]), _vm._v(" "), (video.uploader && video.uploader.id != video.user.id) ? _c('span', {
      staticClass: "bold text-muted"
    }, [_vm._v("\n          (Uploaded by: " + _vm._s(video.uploader.name || video.uploader.email) + ")\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (video.shared) ? _c('div', {
      staticClass: "d-flex align-items-center flex-wrap"
    }, [_c('b', {
      staticClass: "mr-1"
    }, [_vm._v("Shared by")]), _vm._v(" "), _c('span', {
      staticClass: "d-flex align-items-center"
    }, [_c('img', {
      staticClass: "user-profile-image m-0 mr-1",
      attrs: {
        "src": video.user.avatar_url
      }
    }), _vm._v("\n          " + _vm._s(video.user.name || video.user.email) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('time', {
      staticClass: "text-muted bold",
      attrs: {
        "datetime": video.created_on
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("formatTextDate")(video.created_on)) + "\n      ")])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-2af06504"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideosTable.vue
// module id = 1000
// module chunks = 0